import React from 'react';
import { Box, Grid } from '@mui/material';
import { IconButton } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';

const sxStyles = {
    buttonStyle: {
        color:'white',
        backgroundColor:'rgba(0,0,0,0.6)',
        position: 'relative',
        '&:hover': {
            backgroundColor: 'primary.main',
        },
    }
};


function PlayPauseButton(props) {

    let buttonType = (
            <PlayArrowIcon />
    );
    if (props.playing) {
        buttonType = (
            <PauseIcon />
        );
    }
    return (
        <Grid container
            spacing={0}
            direction="row"
            justifyContent="center"
            alignItems="center"
        >
            <Grid item>
                <Box>
                    <IconButton sx={sxStyles.buttonStyle} onClick={props.togglePlay} size='small'>
                        {buttonType}
                    </IconButton>
                </Box>
            </Grid>
        </Grid>
    );
}

export default PlayPauseButton;
